import { ProductController, SizeController, CategoryController } from "controllers";
import { Storage } from "lib/firebase";

export function generateLocationCode(size, category) {
    const s = SizeController.getSizeByValue(size)
    const c = CategoryController.getCategoryByValue(category);

    return s.code + c.code;
};

export function capitalize(text) {
    if (typeof text !== "string") return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export async function handleUpload(file, barcode) {
    const stringData = file.base64.split(",");
    await Storage.ref(`products/${barcode}/${file.name}`).putString(
        stringData[1],
        "base64"
    );

    const url = await Storage.ref(`products/${barcode}`)
        .child(file.name)
        .getDownloadURL();
    return url;
};


/**
 * 
 * @param {*} barcode 
 * @returns an exception if the barcode exists in the database
 */
export async function verifyBarcode(barcode) {
    const isNew = await ProductController.barcodeIsNew(barcode);
    if (!isNew) {
        throw new Error('This barcode is already taken. Please upload a valid one.');
    }
}

export function verifyRequiredFields(fields) {
    const { barcode, color, attributes, category, tags, cuts, supplier, name, size, brand, details } = fields;

    const requiredFields = [
        { name: barcode, message: 'barcode' },
        { name: category, message: 'category' },
        { name: color, message: 'color' },
        { name: attributes, message: 'attributes' },
        { name: tags, message: 'tags' },
        { name: cuts, message: 'cuts' },
        { name: details, message: 'details' },
        { name: supplier, message: 'supplier' },
        { name: name, message: 'name' },
        { name: size, message: 'size' },
        { name: brand, message: 'brand' },
    ];

    for (const field of requiredFields) {
        if (!field.name.length) {
            throw new Error(`Please add ${field.message}.`);
        }
    }
}
